module.exports = __webpack_public_path__ + "assets/img/ai_text.6d78372e.png";